import React, { useState } from 'react';
import axios from 'axios';
import {
    Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    MenuItem, TextField,
} from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { getUrl } from '../../config';

export const MODULE_LABELS = {
    devis: 'Devis',
    commande: 'Commande',
    bon: 'Bon de livraison',
    facture: 'Facture',
    achat: 'Achat',
    demande_prix: 'Demande de prix',
};

/**
 * Envoie l'objet et le corps du template affiché (pas la signature) à un utilisateur du même ERP.
 * Le destinataire doit l'accepter avant qu'il ne remplace son propre template.
 */
function ShareTemplateButton({ module, subject, body }) {
    const [open, setOpen] = useState(false);
    const [users, setUsers] = useState([]);
    const [toUserId, setToUserId] = useState('');
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState(null);

    const handleOpen = () => {
        setOpen(true);
        setFeedback(null);
        setToUserId('');
        axios.get(getUrl() + '/api/email-template-shares/recipients')
            .then((response) => {
                if (response.data.status === 'success') setUsers(response.data.data);
            })
            .catch((error) => {
                console.error('Erreur lors de la récupération des utilisateurs :', error);
                setFeedback({ severity: 'error', text: 'Impossible de charger la liste des utilisateurs' });
            });
    };

    const handleSend = async () => {
        setLoading(true);
        try {
            const response = await axios.post(getUrl() + '/api/email-template-shares', { toUserId, module, subject, body });
            if (response.data.status === 'success') {
                setFeedback({ severity: 'success', text: 'Template envoyé. Il apparaîtra chez la personne pour qu\'elle l\'accepte ou le refuse.' });
                setToUserId('');
            } else {
                setFeedback({ severity: 'error', text: response.data.message || "Erreur lors de l'envoi" });
            }
        } catch (error) {
            setFeedback({ severity: 'error', text: error.response?.data?.message || "Erreur lors de l'envoi" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button variant="outlined" fullWidth startIcon={<ShareIcon />} sx={{ mt: 1 }} onClick={handleOpen}>
                Partager à un collègue
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
                <DialogTitle>Partager le template « {MODULE_LABELS[module] || module} »</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        L'objet et le corps du message affichés actuellement seront envoyés. Votre signature n'est pas partagée.
                    </DialogContentText>
                    {feedback && <Alert severity={feedback.severity} sx={{ mb: 2 }}>{feedback.text}</Alert>}
                    <TextField
                        select
                        fullWidth
                        label="Destinataire"
                        value={toUserId}
                        onChange={(e) => setToUserId(e.target.value)}
                        helperText={users.length === 0 ? 'Aucun autre utilisateur dans cet ERP' : ''}
                    >
                        {users.map((u) => (
                            <MenuItem key={u.id} value={u.id}>{u.name}</MenuItem>
                        ))}
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Fermer</Button>
                    <Button variant="contained" onClick={handleSend} disabled={!toUserId || loading}>Envoyer</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ShareTemplateButton;
